// frontend/src/components/Videos.jsx

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import './styles/EBooks.css';

const Videos = () => {
    const youtubeChannelLink = "https://youtu.be/Y7kaIc0YR48?si=KLyG4BZH8iq0TL5h";

    return (
        <div className="min-h-screen bg-black py-2">
            <div className='border-b border-blue-400 mb-2'>
                <h2 className="text-lg lg:text-xl font-extrabold text-center text-yellow-200 mb-2 p-2">
                ▶️ Think5Whys YouTube Videos
                </h2>
            </div>     
            <div className="min-h-[80vh] flex flex-col justify-center items-center text-white">
                <p className='flex items-center text-center justify-center'>
                    Watch Videos from our experts and Post your own videos too*
                    <br/>Create a 2 minutes story video on what RCA you have done for any issues, challenges, cocerns, incidents, problems
                    <br/>You can create story video for Goal settings or Objective 
                    <br/>After creating video send to us. Our team will review it and post on Think5Whys YouTube channel
                </p>
                <div className="mt-12">
                    <a href={youtubeChannelLink} target="_blank" rel="noopener noreferrer" className="bg-red-600 p-4 rounded-md">
                       ▶️ Watch Videos
                    </a>
                </div>
            </div>
            <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
                <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
                  <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
                  <div className="flex flex-wrap gap-4 text-sm">
                    <Link to="/about-us" className="hover:text-teal-300">About</Link>
                    <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
                    <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
                    <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
                  </div>
                </div>
            </footer>  
        </div>
    );
};

export default Videos;
